export default __webpack_public_path__ + "static/media/classroom 3.16fd90be.JPG";